import React from 'react';
import { REPORT_COLUMNS, formatReportValue } from '../constants';
import * as Style from '../styles';

const EMPHASIS_COLUMNS = ['nome', 'total', 'cota'];

function ReportTableRow({ row, onSssgClick, columns = REPORT_COLUMNS }) {
    const RowContainer = row.isTotal ? Style.TotalRow : Style.DataRow;
    const CellText = row.isTotal ? Style.TotalCellText : Style.DataCellText;

    return (
        <RowContainer>
            {columns.map(column => {
                const formatted = formatReportValue(
                    row[column.key],
                    column.format
                );
                const cellTextProps = row.isTotal
                    ? {
                          emphasis: EMPHASIS_COLUMNS.includes(column.key),
                          accent: column.key === 'nome',
                      }
                    : { primary: column.key === 'nome' };

                return (
                    <Style.TableCell
                        key={column.key}
                        width={column.width}
                        align={column.align}
                        sticky={column.key === 'nome'}
                        background={row.isTotal ? '#4c4746' : '#373435'}
                    >
                        {column.clickable ? (
                            <Style.SssgButton
                                type="button"
                                onClick={() => onSssgClick(row)}
                            >
                                <CellText {...cellTextProps}>
                                    {formatted}
                                </CellText>
                            </Style.SssgButton>
                        ) : (
                            <CellText {...cellTextProps}>{formatted}</CellText>
                        )}
                    </Style.TableCell>
                );
            })}
        </RowContainer>
    );
}

export default ReportTableRow;
